module.exports = __webpack_public_path__ + "static/media/status-suspended.d4fdf2dc.svg";